"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _data = require("./data.js");

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BtnMobile = _styledComponents["default"].a.withConfig({
  displayName: "mobileStoreButton__BtnMobile",
  componentId: "sc-52nbn8-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 8px 10px;\n    justify-content: center;\n    font-family: 'robotoMedium';\n    font-weight: 700;\n    color: ", ";\n    background: ", ";\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 48%;\n    &:first-child {\n        margin-right: 9px;\n    }\n    margin-bottom: 0;\n"])), _constants.COLORS.darkGrey, _constants.COLORS.white);

var BtnMobileImg = _styledComponents["default"].img.withConfig({
  displayName: "mobileStoreButton__BtnMobileImg",
  componentId: "sc-52nbn8-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-right: 10px;\n    align-self: center;\n    opacity: 0.5;\n    ", ":hover & {\n        opacity: 1;\n        transition: 0.25s;\n    }\n"])), BtnMobile);

var MobileStoreButton = function MobileStoreButton(_ref) {
  var store = _ref.store,
      link = _ref.link,
      rest = _objectWithoutProperties(_ref, ["store", "link"]);

  var data = _data.storeData[store];
  return /*#__PURE__*/_react["default"].createElement(BtnMobile, _extends({
    href: link ? link : data.link
  }, rest), /*#__PURE__*/_react["default"].createElement(BtnMobileImg, {
    src: data.img,
    alt: data.alt,
    title: data.title
  }));
};

var _default = MobileStoreButton;
exports["default"] = _default;